import React, { useState, useEffect } from 'react';
import Drawer from '@mui/material/Drawer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { BsList } from 'react-icons/bs';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import Tabs from './Sidebar/Tabs';

const INITIAL_WIDTH = 500;

export default function Handler() {
  const [drawer, setDrawer] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(INITIAL_WIDTH);
  const [isResizing, setIsResizing] = useState(false);
  const [initialX, setInitialX] = useState(0);
  const [initialWidth, setInitialWidth] = useState(INITIAL_WIDTH);

  useEffect(() => {
    const handleMouseMove = (e) => {
      e.preventDefault();
      if (isResizing) {
        const deltaX = initialX - e.clientX;
        const newWidth = initialWidth + deltaX;
        if (newWidth >= Math.ceil(INITIAL_WIDTH / 2) && newWidth <= window.innerWidth) {
          setDrawerWidth(newWidth);
        }
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    if (isResizing) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing, initialX, initialWidth]);

  const handleMouseDown = (e) => {
    setIsResizing(true);
    setInitialX(e.clientX);
    setInitialWidth(drawerWidth);
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          position: 'fixed',
          zIndex: 'tooltip',
          right: 0,
          mx: 1,
        }}
      >
        <IconButton
          onClick={() => setDrawer(!drawer)}
          aria-label={drawer ? 'Close sidebar' : 'Open sidebar'}
        >
          {!drawer && <BsList />}
          {drawer && <CloseIcon />}
        </IconButton>
      </Stack>
      {/* eslint-disable jsx-a11y/no-static-element-interactions */}
      <Drawer
        anchor="right"
        open={drawer}
        onClose={() => setDrawer(false)}
        variant="persistent"
        PaperProps={{ style: { width: drawerWidth } }}
      >
        <Paper elevation={0}>
          <Tabs variant="fullWidth" />
        </Paper>
        <div
          style={{
            width: '9px',
            cursor: 'col-resize',
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            zIndex: 1000,
          }}
          onMouseDown={handleMouseDown}
          className="resize-handle"
        />
      </Drawer>
    </>
  );
}
